module.exports = __webpack_public_path__ + "static/media/Natural Disaster Flood House.9c6e951f.svg";